module.exports = __webpack_public_path__ + "static/soi_large-d40320a28a4dd27d64dc0b50555f569c.jpg";